/**
 * Created by Ning Jiang on 5/9/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {PixiesVsPiratesReelSymbol} from "./PixiesVsPiratesReelSymbol";

export class PPScatterSymbol extends PixiesVsPiratesReelSymbol {

    private static _bgHeight:number = 174;
    private _anchorY:number;

    private _topContainer:PIXI.Container | null;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            this._stateAnimations[stateConfig.keyword]!.anchor.y = this._anchorY;
            return true;
        }
        return false;
    }

    protected addNewStateAnimation(timeline:gsap.TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if(this.currentState!.keyword === GameConfig.instance.SYMBOL_STATES.idle!.keyword) {
            stateAnimation.stopLoop();
        }
        if(newState.state.keyword === GameConfig.instance.SYMBOL_STATES.idle!.keyword) {
            stateAnimation.playLoop();
        }
    }

    protected updateHeightDisplay():void {
        super.updateHeightDisplay();

        this._anchorY = MathHelper.roundToDecimals(((PPScatterSymbol._bgHeight - GameConfig.instance.SYMBOL_HEIGHT) / 2 + GameConfig.instance.SYMBOL_HEIGHT - this.symHeight / 2) / PPScatterSymbol._bgHeight, 2);
        for(let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if(state != null) {
                state.anchor.y = this._anchorY;
            }
        }
    }
}